import EntityChip from '@/atoms/chips/EntityChip';
import TagChip from '@/atoms/chips/TagChip';
import Size from '@enums/Size';
import Stack from '@mui/material/Stack';

const TagLabel = ({ item }) => {
  const { label, props } = item;

  return (
    <Stack direction="row" spacing={0.5}>
      {props.scope && <EntityChip type={props.scope} size={Size.X_SMALL} />}
      <TagChip
        color={props?.color}
        name={label}
        expanded
        size={Size.X_SMALL}
        fontWeight={600}
      />
    </Stack>
  );
};

export default TagLabel;
